import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const StarRating = ({ rate,size="default" }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (rate >= i) {
      stars.push(<FaStar key={i} className={`text-yellow-400  ${size=="large"?"text-2xl":"text-sm"}`} />);
    } else if (rate >= i - 0.5) {
      stars.push(<FaStarHalfAlt key={i} className={`text-yellow-400  ${size=="large"?"text-2xl":"text-sm "}`} />);
    } else {
      stars.push(<FaRegStar key={i} className={`text-yellow-400 ${size=="large"?"text-2xl":"text-sm "}`} />);
    }
  }

  return <div className="flex gap-1">{stars}</div>;
};

export default StarRating;